import requireAuthorization from "@/routes/helper/requireAuthorization";
import { PermitionEnum } from "@/components/security/Permitions";

export default [
    {
        path: "/fonts",
        name: "fonts",
        component: () => import("@/components/fonts/_Fonts.vue"),
        beforeEnter: requireAuthorization,
        meta: {
            permission: PermitionEnum.ViewFontsUI,
            breadcrumbs: {
                icon: "fonts-icon",
                paths: []
            },
            title: "navbar.fonts"
        }
    }
];
